import React from 'react';
import { T } from '../tokens';

export default function FlowDropZone({
  index, active, expanded, onDragOver, onDrop,
}) {
  return (
    <div
      onDragEnter={(e) => {
        e.preventDefault();
        onDragOver(index);
      }}
      onDragOver={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDragOver(index);
      }}
      onDrop={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDrop(index, e);
      }}
      style={{
        width: 260,
        minHeight: expanded ? (active ? 20 : 14) : (active ? 12 : 8),
        margin: expanded ? '4px 0' : '1px 0',
        borderRadius: 999,
        background: active ? T.blue : 'transparent',
        transition: 'min-height .12s ease, background .12s ease, margin .12s ease',
        flexShrink: 0,
      }}
    />
  );
}
